import { gql } from "@/__generated__/gql";

export const LIVE_EVENT_DETAILS = gql(`
query liveEventDetails($eventId: ID!) {
    node(id: $eventId) {
      id
      ... on LiveEvent {
        audience,
        chatChannel {
          displayName
        }
        eventType
        gameType
        gameVariation
        name
        startsAt
      }
    }
  }
`);
